<template>
    <ModalComponent
        :name="name"
        title="Descargar informe"
        v-on:close="() => close(false)"
    >
        <div v-if="! loading">
            <ValidationObserver tag="form" ref="observer" @submit.prevent="submit">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group">
                                <label for="provincias">Formato</label>
                                <multiselect
                                    v-model="formato"
                                    placeholder="Formato"
                                    label="value"
                                    track-by="value"
                                    :options="tipos"
                                    :multiple="false"
                                ></multiselect>
                            </div>                                            
                        </div>
                        <div class="col-12">
                            <div class="form-group">
                                <label for="fecha_envio">Fecha de inicio</label>
                                <datetime 
                                    v-model="fecha_inicio"
                                    input-class="form-control"
                                    type="date"
                                    input-id="fecha_inicio"
                                ></datetime>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-group">
                                <label for="fecha_envio">Fecha de fin</label>
                                <datetime 
                                    v-model="fecha_fin"
                                    input-class="form-control"
                                    type="date"
                                    input-id="fecha_inicio"
                                ></datetime>
                            </div>
                        </div>
                        <div v-if="!lista_id" class="col-12">
                            <div class="form-group">
                                <ValidationProvider name="Sesión" rules="required" v-slot="{ errors }">
                                    <label for="sesion">Sesión</label>
                                    <multiselect
                                        v-model="sesion"
                                        placeholder="Sesión"
                                        track-by="id"
                                        :custom-label="customLabel"
                                        :options="sesiones"
                                        :multiple="false"
                                        :allowEmpty="false"
                                        :disabled="sesiones && sesiones.length == 1"
                                    ></multiselect>
                                    <span v-if="errors[0]" class="d-block bg-danger text-white mt-1 text-xs" style="padding: 5.5px;">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                        </div>
                        <div v-if="!lista_id" class="col-12">
                            <div class="form-group">
                                <label for="sesion">Tipo de venta</label>
                                <multiselect
                                    v-model="tipoVenta"
                                    placeholder="Sesión"
                                    label="value"
                                    track-by="value"
                                    :options="tiposVenta"
                                    :multiple="false"
                                ></multiselect>
                            </div>
                        </div>
                        <b-col cols="12" v-if="name === 'descargar-informe-taquilla'">
                            <div class="form-group">
                                <label for="tipo-informe">Tipo de informe</label>
                                <multiselect
                                    v-model="tipoInforme"
                                    placeholder="Tipo de informe"
                                    label="value"
                                    track-by="id"
                                    :options="tiposInforme"
                                ></multiselect>
                            </div>
                        </b-col>
                    </div>
                </div>
                <div class="text-right">
                    <Button type="submit">DESCARGAR</Button>
                </div>
            </ValidationObserver>
        </div>
        <template v-else>
            <div class="m-0">
                <div class="p-4 m-2">                    
                    <div class="row">
                        <h2>Se esta generando el informe, recibirá una notificación para poder descargarlo cuando esté listo.</h2>
                    </div>
                </div>
            </div>
        </template>
    </ModalComponent>
</template>

<script>
import ModalComponent from "@/components/backend/components/ModalComponent";

export default {
    props: ['url', 'ruta', 'name', 'detalle', 'lista_id', 'evento_id', 'taquillero_id', 'sesiones'],
    data() {
        return {
            loading: false,
            fecha_inicio: null,
            fecha_fin: null,
            tipos: [
                { value: 'xls'},
                { value: 'pdf'}
            ],
            formato: { value: 'xls' },
            sesion: null,
            tiposVenta: [
                { value: 'Taquilla' },
                { value: 'Online' },
                { value: 'Ambas'}
            ],
            tipoVenta: { value: 'Ambas' },
            tiposInforme: [
                { id: 1, value: 'Desglosado' },
                { id: 0, value: 'Sin desglosar' }
            ],
            tipoInforme: { id: 1, value: 'Desglosado' }
        }
    },
    created() {
        if(this.sesiones && !this.lista_id && this.sesiones.length == 1) {
            this.sesion= this.sesiones[0];
        }
    },
    computed: {
        configuracion() {
            return this.$store.getters.getConfig;
        }
    },
    methods: {
        close() {
            this.loading = false;
            this.$emit('close', this.name);
        },
        async submit() {
            const isValid = await this.$refs.observer.validate();
            if(isValid) {
                if(this.evento_id && this.formato.value == 'pdf'){
                    var enlace = this.config.API_BASE + '/eventos/' + this.evento_id + '/descargar/pdf?api_key=' + localStorage.getItem('token') + '&fecha_inicio=' + this.fecha_inicio + '&fecha_fin=' + this.fecha_fin + '&detalle=' + this.detalle + '&tid=' + this.configuracion.hash_teatro;
                    window.open(enlace);
                    this.close(false);
                }else {
                    this.getInforme();
                }

            }
        },
        getInforme() {
            this.loading = true;
            const params = {
                filters : {
                    fecha_inicio: this.fecha_inicio,
                    fecha_fin: this.fecha_fin,
                    lista_id: this.lista_id,
                    formato: this.formato.value,
                    detalle: this.detalle,
                    format: this.formato.value == 'csv' || this.formato.value == 'xls' ? 'csv' : 'pdf',
                    evento_id: this.evento_id,
                    taquillero_id: this.taquillero_id ?? null,
                    sesion_id: this.lista_id ? null : this.sesion.id,
                    tipo_venta: this.lista_id ? null : this.tipoVenta.value
                },
                lista_id: this.lista_id,
                evento_id: this.evento_id
            };
            if (this.name === 'descargar-informe-taquilla') {
                params.filters.desglosado = this.tipoInforme.id;
            }

            this.$store.dispatch(this.config.getVuexAlias(this.ruta), params).then(res => {
                this.loading = true
            });
        },
        customLabel(sesion) {
            var texto = sesion.fecha;

            if (sesion.text) {
                texto += (' - ' + sesion.text)
            }

            return texto; 
        }
    },
    components: {
        ModalComponent
    }
}
</script>
